import { render, staticRenderFns } from "./Office.vue?vue&type=template&id=2d2b84c1&scoped=true"
import script from "./Office.vue?vue&type=script&lang=ts"
export * from "./Office.vue?vue&type=script&lang=ts"
import style0 from "./Office.vue?vue&type=style&index=0&id=2d2b84c1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d2b84c1",
  null
  
)

export default component.exports